<script>
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

export default {
    name: 'BrowseRecentlyPlayedMixes',
    components: { MixGridBlock },
    data() {
        return {
            mixes: [],
            LIMIT: 24,
            offset: 0,
            isFull: false,
        }
    },
    page() {
        const title = 'Recently Played'
        const description = 'Recently played DJ mixes on FRISKY.'
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    computed: {
        recentlyPlayedMixes() {
            return (
                this.$store.state.playback &&
                this.$store.state.playback.history &&
                this.$store.state.playback.history.reduce(
                    (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
                    []
                )
            )
        },
    },
    watch: {
        recentlyPlayedMixes: {
            handler() {
                this.getMixes()
            },
        },
    },
    mounted() {
        this.getMixes()
    },
    methods: {
        getMixes() {
            const promises =
                this.recentlyPlayedMixes &&
                this.recentlyPlayedMixes.length &&
                this.recentlyPlayedMixes.map(id => DataLayer.mixes.getById(id))
            promises &&
                promises.length &&
                Promise.all(promises).then(values => {
                    const mixes = []
                    values.map((res, i) => mixes.push(res.body))
                    this.mixes = mixes
                })
        },
    },
}
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>

<style lang="scss" module>
@import '@design';
</style>
